import React, { useEffect, useMemo } from "react";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import Fade from "@material-ui/core/Fade";

import "./style.scss";

const Calendar = ({
  diasDisponiveis,
  largura,
  altura,
  setDataAtual,
  setData,
}) => {
  const date = useMemo(() => {
    return new Date();
  }, []);

  useEffect(() => {
    renderCalendar();
  }, []);

  useEffect(() => {
    if (date != undefined) {
      // para abrir o calendário na data do primeiro agendamento
      // let day =;

      date.setDate(1);

      date.setMonth(parseInt(diasDisponiveis[0]?.split("-")[1] - 1));

      date.setFullYear(diasDisponiveis[0]?.split("-")[0]);

      renderCalendar();
    }
  }, [diasDisponiveis]);

  const renderCalendar = () => {
    const monthdias = document.querySelector(".dias");

    setDataAtual({ mes: date.getMonth() + 1, ano: date.getFullYear() });

    // pega o último dia do mês corrente
    const lastDay = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0
    ).getDate();
    // pega o último dia do mês passado
    const prevLastDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      0
    ).getDate();

    // pega o dia da semana que o mês corrente inicia (0 == domingo, 1 == segunda até 6 == sábado)
    const firstDayIndex = date.getDay();

    // pega o dia da semana que o mês corrente finaliza (0 == domingo, 1 == segunda até 6 == sábado)
    const lastDayIndex = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0
    ).getDay();

    const nextdias = 7 - lastDayIndex - 1;

    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];

    document.querySelector(".date h1").innerHTML =
      months[date.getMonth()] + " - " + date.getFullYear();

    // document.querySelector(".date p").innerHTML = new Date().toDateString();

    let dias = "";

    for (let x = firstDayIndex; x > 0; x--) {
      dias += `<div class="prev-date">${prevLastDay - x + 1}</div>`;
    }

    // montagem dos dia no calendário
    for (let i = 1; i <= lastDay; i++) {
      var diaDisponivel = false;

      // monta string para fazer a comparação com o array de agentes disponíveis
      let day =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) +
        "-" +
        (i < 10 ? "0" + i : i);

      // função que seleciona todos os dias disponíveis para agendamento
      // só irão receber a classe agendamento os dias que há algum 'interval' disponível
      if (diasDisponiveis.includes(day)) {
        diaDisponivel = true;
        dias += `<div class=" acompanhar-agendamento centralized" name=${
          i < 10 ? "0" + i : i
        }/${
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1
        }/${date.getFullYear()}  data=${day}>
          <span class="acompanhar-agendamento-span centralized"
          name=${i < 10 ? "0" + i : i}/${
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1
        }/${date.getFullYear()}  data=${day}
          >${i < 10 ? "0" + i : i}</span></div>`;
      }

      // carrega o dia que não tiver agendamento disponível
      if (diaDisponivel == false) {
        dias += `<div name=${i < 10 ? "0" + i : i}/${
          date.getMonth() + 1
        }/${date.getFullYear()} data=${day}>${i < 10 ? "0" + i : i}</div>`;
      }
    }

    // carrega os dias do mês seguinte
    for (let k = 1; k <= nextdias; k++) {
      dias += `<div class="next-date">${k}</div>`;
    }

    // monta o calendário
    monthdias.innerHTML = dias;

    // pega exatamente os dias do mês
    let diasDoMes = Array.from(
      document.getElementsByClassName("acompanhar-agendamento-span")
    );
    diasDoMes.forEach((item) => {
      item.addEventListener("click", (event) => {
        setData(event.target.attributes[2].value);
      });
    });
  };

  return (
    <Fade in>
      <div
        className="calendar"
        style={{
          width: largura,
          height: altura,
        }}
      >
        <div className="mes">
          <div className="date">
            <h1></h1>
          </div>
          <div className="monthSelector">
            <span
              className="prev"
              onClick={() => {
                date.setMonth(date.getMonth() - 1);
                renderCalendar();
              }}
            >
              <ArrowLeftIcon style={{ fill: "#003DA5", fontSize: "24px" }} />
            </span>
            <span
              className="next"
              onClick={() => {
                date.setMonth(date.getMonth() + 1);
                renderCalendar();
              }}
            >
              <ArrowRightIcon style={{ fill: "#003DA5", fontSize: "24px" }} />
            </span>
          </div>
        </div>
        <div className="weekdias">
          <div>Dom</div>
          <div>Seg</div>
          <div>Ter</div>
          <div>Qua</div>
          <div>Qui</div>
          <div>Sex</div>
          <div>Sab</div>
        </div>
        <div className="dias"></div>
        <div className="comAgendamento centralized">
          <div className="comAgendamento__icone"></div>
          <span>Dia com agendamento</span>
        </div>
      </div>
    </Fade>
  );
};

export default Calendar;
